import React from "react";
import styled from "styled-components";
import {IdeaAction} from "./IdeaAction";
import {PortfolioMessageAction} from "./PortfolioMessageAction";
import {EarningsAlert} from "./EarningsAlert";

const Container = styled.div`
    margin-bottom: 6px;
    border: 1px solid rgba(159, 167, 178, 0.32);
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: white;
`;

const actionRenderers = {
    ideaAction: IdeaAction,
    portfolioMessage: PortfolioMessageAction,
    earningsAlert: EarningsAlert
};

export const ActionRow = ({action, onClick, className}) => {
    const Renderer = actionRenderers[action.actionType];
    if (!Renderer) return null;

    return (
        <Container className={`t-activity-row ${className}`} onClick={() => onClick(action)}>
            <Renderer action={action} />
        </Container>
    );
};
